<div class="bell-wrapper">
  <button
    type="button"
    class="bell-trigger"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    [attr.aria-label]="ariaLabel()"
    matTooltip="Notificações"
    matTooltipPosition="below"
    matTooltipClass="induxtry-tooltip"
    [matTooltipDisabled]="isOpen()"
    (click)="toggle()">
    <mat-icon class="bell-icon" svgIcon="Notification"></mat-icon>
    @if (inbox.unreadCount() > 0) {
      <span class="bell-badge">{{ badgeLabel() }}</span>
    }
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayPush]="true"
    (backdropClick)="close()"
    (detach)="close()">
    <div class="bell-dropdown" role="dialog" aria-label="Notificações">
      <header class="bell-header">
        <p class="bell-title">Notificações</p>
        @if (inbox.unreadCount() > 0) {
          <button type="button" class="bell-mark-all" (click)="markAllRead($event)">
            Marcar todas como lidas
          </button>
        }
      </header>

      @if (inbox.isLoading()) {
        <div class="bell-list" role="status" aria-label="Carregando notificações">
          @for (row of skeletonRows; track row) {
            <div class="bell-item bell-item--skeleton" aria-hidden="true">
              <span class="bell-skel bell-skel-title"></span>
              <span class="bell-skel bell-skel-summary"></span>
              <span class="bell-skel bell-skel-date"></span>
            </div>
          }
        </div>
      } @else if (!inbox.items().length) {
        <p class="bell-empty">Nenhuma notificação</p>
      } @else {
        <div class="bell-list">
          @for (item of inbox.items(); track item._id) {
            <button
              type="button"
              class="bell-item bell-item--unread"
              (click)="markRead(item._id, $event)">
              <span class="bell-item-title">{{ item.alert_name }}</span>
              <span class="bell-item-summary">{{ item.summary }}</span>
              <span class="bell-item-date">{{ item.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
            </button>
          }
        </div>
      }
    </div>
  </ng-template>
</div>
